import { render, staticRenderFns } from "./SiteBlocks.vue?vue&type=template&id=8a4875e0&"
import script from "./SiteBlocks.vue?vue&type=script&lang=js&"
export * from "./SiteBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports